(function () {
  'use strict';

  var ACCOUNT_SELECTOR = '[data-p4m-rewards-summary][data-p4m-customer-authenticated="true"]';
  var VALUE_SELECTOR = '[data-p4m-rewards-value]';
  var retryTimer = null;
  var retryCount = 0;
  var syncInFlight = false;
  var balanceRendered = false;

  function parsePoints(value) {
    if (value === null || value === undefined || value === '') return null;

    var points = Number(String(value).replace(/,/g, ''));
    if (!Number.isFinite(points) || points < 0) return null;

    return Math.floor(points);
  }

  function pointsFromCustomer(payload) {
    var customer = payload && payload.customer ? payload.customer : payload;
    if (!customer) return null;

    return parsePoints(customer.points_balance);
  }

  function formatPoints(points) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US').format(points);
    } catch (error) {
      return String(points);
    }
  }

  function renderBalance(points) {
    var formattedPoints = formatPoints(points);

    document.querySelectorAll(ACCOUNT_SELECTOR).forEach(function (account) {
      var value = account.querySelector(VALUE_SELECTOR);
      if (value) {
        value.innerHTML = 'You have <span class="p4m-header-rewards-points">' + formattedPoints + '</span> points';
      }

      account.setAttribute('aria-label', 'Open your P4M account and rewards. You have ' + formattedPoints + ' points.');
      account.setAttribute('data-p4m-rewards-loaded', 'true');
    });
  }

  async function smileCustomer() {
    var customerPromise = window.__smile_ui_customer_data__;
    if (customerPromise && typeof customerPromise.then === 'function') {
      var payload = await customerPromise;
      if (payload) return payload.customer || payload;
    }

    if (window.SmileShopify && typeof window.SmileShopify.customerReady === 'function') {
      return window.SmileShopify.customerReady();
    }

    return null;
  }

  function stopRetrying() {
    if (!retryTimer) return;
    window.clearTimeout(retryTimer);
    retryTimer = null;
  }

  async function syncBalance() {
    if (balanceRendered || syncInFlight || !document.querySelector(ACCOUNT_SELECTOR)) return;

    syncInFlight = true;

    try {
      var customer = await smileCustomer();
      var points = pointsFromCustomer(customer);

      if (points !== null) {
        renderBalance(points);
        balanceRendered = true;
        stopRetrying();
      }
    } catch (error) {
      // Smile can initialize after the theme. The bounded retry below handles that delay.
    } finally {
      syncInFlight = false;
    }
  }

  function scheduleSync() {
    if (balanceRendered || retryCount >= 80 || !document.querySelector(ACCOUNT_SELECTOR)) return;

    retryCount += 1;
    syncBalance();
    retryTimer = window.setTimeout(scheduleSync, 250);
  }

  function start() {
    if (!document.querySelector(ACCOUNT_SELECTOR)) return;
    scheduleSync();
  }

  document.addEventListener('smile-shopify-loaded', syncBalance);
  document.addEventListener('smile-lite-loaded', syncBalance);
  document.addEventListener('smile-ui-loaded', syncBalance);

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    balanceRendered = false;
    retryCount = 0;
    stopRetrying();
    scheduleSync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
